import { http } from "./http";

/**
 * Git remoto OPCIONAL do projeto (GitHub, GitLab, servidor genérico).
 * O versionamento primário continua sendo o Git local do workspace: se nada
 * for conectado aqui, todo o Builder segue funcionando normalmente.
 * O token nunca volta do backend — apenas o indicador `has_token`.
 */

export interface GitRemoteProviderOption {
  key: string;
  label: string;
  requires_token: boolean;
}

export interface GitRemote {
  uuid: string;
  provider: string;
  name: string;
  repository_url: string;
  default_branch: string;
  username: string | null;
  has_token: boolean;
  is_active: boolean;
  last_status: string | null;
  last_message: string | null;
  last_synced_at: string | null;
}

export interface GitRemoteStatus {
  providers: GitRemoteProviderOption[];
  local: {
    repository: boolean;
    branch: string | null;
    branches: string[];
    head: string | null;
    pending_changes: number;
  };
  remote: GitRemote | null;
}

export interface GitRemoteOperation {
  ok: boolean;
  message: string;
  branch?: string;
}

export interface ConnectRemoteInput {
  provider: string;
  repository_url: string;
  default_branch?: string;
  username?: string;
  access_token?: string;
}

export const gitRemoteService = {
  status: (project: string) => http.get<GitRemoteStatus>(`/projects/${project}/git/remote`),
  connect: (project: string, input: ConnectRemoteInput) =>
    http.post<GitRemote>(`/projects/${project}/git/remote`, input),
  disconnect: (project: string) => http.delete(`/projects/${project}/git/remote`),
  test: (project: string) =>
    http.post<GitRemoteOperation>(`/projects/${project}/git/remote/test`, {}),
  push: (project: string, branch?: string) =>
    http.post<GitRemoteOperation>(`/projects/${project}/git/remote/push`, { branch }),
  pull: (project: string, branch?: string) =>
    http.post<GitRemoteOperation>(`/projects/${project}/git/remote/pull`, { branch }),
};
